import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
  WarningOutlined,
  InfoOutlined,
  ChevronRight as RightArrow,
  Done as CheckIcon,
} from '@mui/icons-material';

import {
  IconButton,
  Drawer,
  Badge,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Tab,
  Tabs,
  AppBar,
  Button,
} from '@mui/material';
import { red } from '@mui/material/colors';
import PermissionsCheck, { hasUserPermission } from '../PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../constants/PermissionsEnum';

class AlertsDrawer extends PureComponent {
  render() {
    return (
      <div>
        <IconButton
          onClick={this.props.onToggleAlertsDrawer}
          data-qa="qa-alerts-drawer"
          size="large"
        >
          <Badge
            badgeContent={this.props.totalNumberOfAlerts || '0'}
            color="error"
            showZero
            invisible={!hasUserPermission(PermissionsEnum.VIEW_ALERTS)}
          >
            <Badge
              badgeContent={this.props.notificationsNumber || '0'}
              color="secondary"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              showZero
            >
              <WarningOutlined
                fontSize="large"
                style={{ color: red[500], marginRight: '10px', marginLeft: '10px' }}
              />
            </Badge>
          </Badge>
        </IconButton>
        <Drawer
          anchor="right"
          width={600}
          open={this.props.open}
          onClose={this.props.onToggleAlertsDrawer}
        >
          <AppBar position="static" color="default">
            <PermissionsCheck permission={PermissionsEnum.VIEW_ALERTS}>
              <Tabs
                value={this.props.notificationType}
                onChange={this.props.onChangeNotificationType}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
              >
                <Tab
                  label={`Alerts ${this.props.alerts.length}/${this.props.totalNumberOfAlerts} `}
                />
                <Tab label={`Notifications ${this.props.notificationsNumber || '0'}`} />
              </Tabs>
            </PermissionsCheck>
            <PermissionsCheck permission={PermissionsEnum.VIEW_ALERTS} hasPermission={false}>
              <Tabs
                value={this.props.notificationType}
                onChange={this.props.onChangeNotificationType}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
              >
                <Tab label={`Notifications ${this.props.notificationsNumber || '0'}`} />
              </Tabs>
            </PermissionsCheck>
          </AppBar>

          {this.props.notificationType == 0 && hasUserPermission(PermissionsEnum.VIEW_ALERTS) ? (
            this.props.alerts.length != 0 ? (
              <div>
                <div className="u-ma-half" style={{ textAlign: 'right' }}>
                  <Button
                    variant="outlined"
                    data-qa="qa-acknowledge-all-alerts"
                    onClick={() => this.props.onClickAcknowledgeAll()}
                  >
                    Acknowledge all
                  </Button>
                </div>

                <List
                  dense={true}
                  onWheel={this.props.onLoadMoreNotifications}
                  style={{ overflowY: 'scroll' }}
                >
                  {this.props.alerts.map((alert, index) => (
                    <ListItem key={index}>
                      <ListItemIcon>
                        <WarningOutlined />
                      </ListItemIcon>
                      <ListItemText
                        primary={`Alert for ${alert.instrumentSerialNumber}:`}
                        secondary={formatJson(alert.message)}
                      />
                      <RightArrow
                        onClick={() =>
                          this.props.onClickAlert(
                            alert.instrumentSerialNumber,
                            alert.data.ReferenceDate
                          )
                        }
                        data-qa="qa-redirect"
                      />
                      <CheckIcon
                        onClick={() =>
                          this.props.onClickAcknowledge(
                            alert.instrumentSerialNumber,
                            alert.data.ReferenceDate,
                            alert.data.MessageType
                          )
                        }
                        fontSize="small"
                        data-qa="qa-acknowledge"
                      />
                    </ListItem>
                  ))}
                </List>
              </div>
            ) : null
          ) : this.props.notifications.length != 0 ? (
            <div>
              <div className="u-ma-half" style={{ textAlign: 'right' }}>
                <Button
                  variant="outlined"
                  data-qa="qa-clear-all-notifications"
                  onClick={() => this.props.onClickClearAll()}
                >
                  Clear all
                </Button>
                <List dense={true}>
                  {this.props.notifications.map((alert, index) => (
                    <ListItem>
                      <ListItemIcon>
                        <InfoOutlined />
                      </ListItemIcon>
                      <ListItemText
                        primary={`UI notification @ ${alert.time}:`}
                        secondary={formatJson(alert.message)}
                      />
                    </ListItem>
                  ))}
                </List>
              </div>
            </div>
          ) : null}
        </Drawer>
      </div>
    );
  }
}

const formatJson = (value) => {
  if (typeof value !== 'string' || value[0] !== '{') {
    return <div>{value}</div>;
  }

  let entity = JSON.parse(value);
  let listItems = Object.keys(entity).map((key) => {
    return (
      <li>
        {key}: {JSON.stringify(entity[key])}
      </li>
    );
  });

  return (
    <div>
      <ul>{listItems}</ul>
    </div>
  );
};

AlertsDrawer.propTypes = {
  open: PropTypes.bool,
  notifications: PropTypes.array,
  onToggleAlertsDrawer: PropTypes.func,
  onChangeNotificationType: PropTypes.func,
  onClickAlert: PropTypes.func,
};

AlertsDrawer.defaultProps = {
  open: false,
  notifications: [],
  notificationType: 0,
  onToggleAlertsDrawer: () => {},
  onChangeNotificationType: () => {},
  onClickAlert: () => {},
};

export default AlertsDrawer;
